import React from "react";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { filterByLink } from "../../../../store/issuesSlice";
import { LinkToReportTab } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const PolicyChanges = ({ diffPolicies, }) => {
    const dispatch = useReportDispatch();
    const added = diffPolicies
        .filter((change) => change.change !== "removed")
        .map((change, index) => {
        const [issue, description] = change.current.split(" - ");
        return (React.createElement("div", { key: change.current, className: styles["change-line"] },
            React.createElement(LinkToReportTab, { underline: "hover", id: `diff-modified-policy-change-link-${index}`, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, className: styles["issue-link"], inline: true, onClick: () => dispatch(filterByLink({
                    issue: { operation: "is", values: [issue] },
                })), color: "link" }, issue),
            description ? ` - ${description}` : null));
    });
    const removed = diffPolicies
        .filter((change) => change.change === "removed")
        .map((change) => {
        const [issue, description] = change.previous.split(" - ");
        return (React.createElement("div", { key: change.previous, className: styles["change-line"] },
            React.createElement("strong", null, issue),
            description ? ` - ${description}` : null));
    });
    return React.createElement(ChangeCategoryCard, { title: "Issues", added: added, removed: removed });
};
export default PolicyChanges;
//# sourceMappingURL=PolicyChanges.js.map